import { timeAgo } from '../../lib/time'
import Avatar from '../ui/Avatar'

export default function SweatResultFeedCard({ item, onUserTap }) {
  const { winners, losers, game } = item
  const allUsers = [...winners, ...losers]

  const visibleUsers = allUsers.slice(0, 3)
  const extraCount = allUsers.length - 3

  const headerText = winners.length > 0 && losers.length > 0
    ? `${winners.length} won, ${losers.length} lost`
    : winners.length > 0
    ? 'The results are in'
    : 'Tough break'

  return (
    <div className="bg-bg-primary border border-correct/30 rounded-xl overflow-hidden border-l-4 border-l-correct feed-victory-entrance">
      {/* Header: avatar stack + text */}
      <div className="px-4 pt-3 pb-2 flex items-center gap-3">
        <div className="flex items-center flex-shrink-0">
          {visibleUsers.map((user, i) => (
            <button
              key={user.userId}
              onClick={() => onUserTap?.(user.userId)}
              className="hover:ring-2 hover:ring-accent/30 transition-shadow rounded-full"
              style={{ marginLeft: i > 0 ? '-8px' : 0, zIndex: visibleUsers.length - i }}
            >
              <Avatar
                user={{ avatar_url: user.avatar_url, avatar_emoji: user.avatar_emoji, username: user.username, display_name: user.display_name }}
                size="lg"
                className="ring-2 ring-bg-card"
              />
            </button>
          ))}
          {extraCount > 0 && (
            <span
              className="w-8 h-8 rounded-full bg-bg-primary text-xs font-bold text-text-muted flex items-center justify-center ring-2 ring-bg-card flex-shrink-0"
              style={{ marginLeft: '-8px', zIndex: 0 }}
            >
              +{extraCount}
            </span>
          )}
        </div>

        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium text-correct leading-tight">
            {headerText}
          </div>
        </div>
        <span className="text-xs text-text-muted flex-shrink-0">{timeAgo(item.timestamp)}</span>
      </div>

      {/* Card body */}
      <div className="px-4 pb-3">
        {/* Sport tag */}
        {game.sport_name && (
          <span className="text-[10px] uppercase tracking-wider text-text-muted font-semibold">
            {game.sport_name}
          </span>
        )}

        {/* Matchup */}
        <div className="text-sm text-text-secondary mt-0.5 mb-2">
          {game.away_team} @ {game.home_team}
        </div>

        {/* Winners */}
        {winners.length > 0 && (
          <div className="space-y-1 mb-2">
            {winners.map((w) => (
              <div key={w.userId} className="flex items-center justify-between text-xs bg-correct/10 rounded-lg px-2 py-1.5">
                <div className="flex items-center gap-2">
                  <span className="font-bold text-correct">W</span>
                  <button
                    onClick={() => onUserTap?.(w.userId)}
                    className="text-accent hover:underline font-medium"
                  >
                    @{w.username}
                  </button>
                  <span className="text-text-muted">{w.picked_team_name}</span>
                </div>
                <span className="font-bold text-correct">+{w.points_earned}</span>
              </div>
            ))}
          </div>
        )}

        {/* Losers */}
        {losers.length > 0 && (
          <div className="space-y-1">
            {losers.map((l) => (
              <div key={l.userId} className="flex items-center justify-between text-xs bg-incorrect/10 rounded-lg px-2 py-1.5">
                <div className="flex items-center gap-2">
                  <span className="font-bold text-incorrect">L</span>
                  <button
                    onClick={() => onUserTap?.(l.userId)}
                    className="text-accent hover:underline font-medium"
                  >
                    @{l.username}
                  </button>
                  <span className="text-text-muted">{l.picked_team_name}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
